import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { SCROLL_SECTIONS } from "@/lib/site";
import { scrollToHash } from "@/lib/motion";

export default function Header({ solid = false }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, id) => {
    e.preventDefault();
    setOpen(false);
    if (window.location.pathname !== "/") {
      window.location.href = `/#${id}`;
      return;
    }
    scrollToHash(id);
  };

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 border-b bg-[#f3f3e9]"
      style={{ borderColor: "var(--line)", boxShadow: scrolled ? "0 10px 30px -18px rgba(18,61,48,.35)" : "none" }}
    >
      <div className="wrap flex h-[68px] items-center justify-between gap-4">
        <Link to="/" aria-label="OFIC 2026 home" data-testid="header-logo-link" onClick={() => setOpen(false)}>
          <img src="/assets/ofic-mark.png" alt="OFIC 2026" className="h-10 w-auto" />
        </Link>
        <nav className="hidden items-center gap-7 lg:flex" data-testid="header-nav">
          {SCROLL_SECTIONS.map(([id, label]) => (
            <a
              key={id}
              href={`#${id}`}
              onClick={(e) => go(e, id)}
              className="text-[13px] font-bold text-[#123d30] no-underline opacity-80 transition-opacity hover:opacity-100"
            >
              {label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/register" data-testid="header-register-btn" className="ofic-btn ofic-btn-forest !px-5 !py-2.5 text-[13px]">
            Register now <span className="arrow">↗</span>
          </Link>
          <button
            data-testid="header-mobile-menu-btn"
            aria-label="Open menu"
            aria-expanded={open}
            onClick={() => setOpen(!open)}
            className="grid h-10 w-10 place-items-center rounded-full lg:hidden"
            style={{ border: "1.5px solid var(--line)" }}
          >
            {open ? "✕" : "☰"}
          </button>
        </div>
      </div>
      {open && (
        <nav data-testid="header-mobile-nav" className="border-t bg-[#f3f3e9] px-6 py-4 lg:hidden" style={{ borderColor: "var(--line)" }}>
          {SCROLL_SECTIONS.map(([id, label]) => (
            <a key={id} href={`#${id}`} onClick={(e) => go(e, id)} className="block py-3 text-base font-bold no-underline">
              {label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}
